module.exports = "<div class=\"copyright text-align-center\">\n  Copyright &copy; {{ year }} <span>Dental Pro.</span> All Rights Reserved.\n</div>"